import React from 'react';
import bindAll from 'lodash.bindall';
import styles from'./uploadToCompetition.css';
import competitionSvg from './competition.svg';
import Fileossupload from '../../containers/oss-upload-file-competition.jsx';
class AixiongReload extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleReload'
        ]);
    }
    handleReload(saveworksCallback){
        // window.location.reload(true);
        return () => {
            saveworksCallback()
        }
    }
    render () {
        return (
            <div className={styles.dropdown} style={{position: 'absolute', right: '120px'}}>
                <div>
                    <div style={{display:'flex', alignItems:'center'}}>
                        <div className={styles.dropbtn}>
                        <a 
                            target="_blank"
                            href="https://vod.e-ai-edu.com/original/workflow/2497be80-1790ddcd720-0004-74eb-db0-f41c5.mp4"
                            style={{
                                color: '#fff',
                                textDecoration: 'none',
                                lineHeight: '48px',
                                height: '48px'
                            }}
                        >作品教程</a>
                    </div>
                        
                    </div>
                </div>
            </div>
        );
    }
};

export default AixiongReload;
